import { projectClient } from '../../client/client';

export const m2m = {
  list: projectClient('/m2m').get,
  create: projectClient('/m2m').post,
  get: projectClient('/m2m/{id}').get,
  delete: projectClient('/m2m/{id}').delete,
  update: projectClient('/m2m/{id}').patch,
  rotateSecret: projectClient('/m2m/{id}/rotate-secret').post,
  listV2: projectClient('/m2m/v2/list').get,
};
